/**
 * @desc directive that checks whether # of factories > 1 and multiFactoryOnly is true
 */

(function() {
	'use strict';

	angular
		.module('app.supplyChain')
		.directive('crossSiteFactoryValidate', crossSiteFactoryValidate);

	function crossSiteFactoryValidate() {
		var directive = {
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, ctrl) {
			var validate = function(factories) {
				var multiFactoryOnly = $attrs.crossSiteFactoryValidate;
				var isValid = false;
				if (multiFactoryOnly == 'false') {
					isValid = true;
				} else {
					isValid = (factories && factories.length >= 1);
				}
				ctrl.$setValidity('cross-site-factory-validate', isValid);
				return factories;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('crossSiteFactoryValidate', function() {
				return validate(ctrl.$viewValue);
			});
		}
	}
})();
